import { useEffect } from "react";
import { useNavigate } from "react-router";
import { URLOpenListenerEvent } from "@capacitor/app";
import { useShallow } from "zustand/react/shallow";
import { useCommonStore } from "../../store/commonStore";

function DeepLinkHandler() {
  const navigate = useNavigate();
  const { setCloseBrowser } = useCommonStore(
    useShallow((state) => ({
      setCloseBrowser: state.setCloseBrowser,
    }))
  );

  useEffect(() => {
    handleDeepLink();
  }, []);

  const handleDeepLink = async () => {
    if (import.meta.env.VITE_PLATFORM === "mobile") {
      const { App } = await import("@capacitor/app");

      App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
        console.log("event", event);

        const slug = event.url.split("/open").pop();

        if (slug) {
          doNavigate(slug);
        }
      });
    }
  };

  const doNavigate = async (slug: string) => {
    setCloseBrowser(true);
    await new Promise((resolve) => setTimeout(resolve, 50));
    navigate(slug);
  };

  return null;
}

export default DeepLinkHandler;
